import { render, staticRenderFns } from "./OAuthSuccess.vue?vue&type=template&id=28e9cb6e&scoped=true"
import script from "./OAuthSuccess.vue?vue&type=script&lang=ts"
export * from "./OAuthSuccess.vue?vue&type=script&lang=ts"
import style0 from "./OAuthSuccess.vue?vue&type=style&index=0&id=28e9cb6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e9cb6e",
  null
  
)

export default component.exports